import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69d5e3d77e3d950014d64acd/licensechecker/src/app/public-license-checker/components/PublicCheckerClient.tsx");
